import React from "react";

export const MunicipalityDetailContext = React.createContext(null);

export const useMunicipalityDetailContext = () => {
  const context = React.useContext(MunicipalityDetailContext);

  if (!context) throw new Error("Municipality Detail Context not provided!");

  return context;
};
